import DealerErrorsFactory from '../Errors/factory.js'
import {GetDealerRequest} from './GetDealerRequest.js'
import {SearchResultsDealerRequest} from './SearchResultsDealerRequest.js'

export class DealerRequestsFactory {
  static getDealerRequest = ({contractId} = {}) => {
    GetDealerRequest.validate({
      contractId,
      invalidDealerRequestError: DealerErrorsFactory.getDealerError
    })

    return new GetDealerRequest({contractId})
  }

  static searchResultsDealerRequest = ({filters, pagination, sort} = {}) => {
    return new SearchResultsDealerRequest({filters, pagination, sort})
  }
}
